import React, { useEffect } from 'react';
import Header from '../../../../header';
import Footer from '../../../../footer';
import worldcupDetailsImage from '../../../../../assets/images/wordcupDetailsImage.png';
import trainingProgram from '../../../../../assets/images/trainingProgram.png';
import organisation from '../../../../../assets/images/organisation.png';
import locationEventImages from '../../../../../assets/images/locationEventImages.png';
import TimerEvent from './timerEvent';
import CustomButton from '../../../../../components/customButton';
import EventForms from './forms';
import { useSelector } from 'react-redux';
import { langSelector } from '../../../../../store/langSlice';
import { getLang } from '../../../../../environnement';

function Item({
  icon,
  primary=false,
  label
}) {
  return (
    <div className='flex flex-col items-center w-1/3'>
      <div className={`bg-white z-20 w-20 h-20 sm:w-40 sm:h-40 rounded-full border-2 border-primary flex justify-center items-center p-5`}>
        <img src={icon} alt='icon' />
      </div>
      <div className={`${primary ? 'bg-primary' : 'bg-[#7C162A]'} w-full h-40 sm:h-60 flex justify-center items-center z-10 relative bottom-11 sm:bottom-20`}>
        <p className='text-sm sm:text-xl md:text-3xl text-white font-medium relative top-5 sm:top-8 w-[250px] text-center px-2'>{label}</p>
      </div>
    </div>
  );
}

function SecondItem({
  icon,
  primary=false,
  label
}) {
  return (
    <div className='flex flex-col items-center w-1/3'>
      <div className={`${primary ? 'bg-primary' : 'bg-[#7C162A]'} w-full h-40 sm:h-60 flex justify-center items-center z-10`}>
        <p className='w-full text-sm sm:text-xl md:text-3xl text-white font-medium relative bottom-5 sm:bottom-8 w-[250px] text-center px-2'>{label}</p>
      </div>
      <div className={`bg-white z-20 w-20 h-20 sm:w-40 sm:h-40 rounded-full border-2 border-primary flex justify-center items-center p-5 relative bottom-11 sm:bottom-20`}>
        <img src={icon} alt='icon'/>
      </div>
    </div>
  );
}

export default function WorldcupDetails() {
  const firstItems = [
    {primary: true, icon: trainingProgram, label: 'Programmes Innovants'},
    {primary: false, icon: trainingProgram, label: 'Prix intéressants'},
    {primary: true, icon: trainingProgram, label: 'Ateliers pratiques'},
  ];

  const secondItems = [
    {primary: false, icon: trainingProgram, label: 'Conférences'},
    {primary: true, icon: trainingProgram, label: 'Concours de simulation'},
    {primary: false, icon: trainingProgram, label: 'Communications scientifiques'},
  ];

  const lang = useSelector(langSelector);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div>
      <Header />
      <div>
        <div className='relative h-40 sm:h-64'>
          <img src={worldcupDetailsImage} alt='headerImage' className='w-full h-40 sm:h-64'/>
          <div className='absolute top-0 left-0 w-full h-full flex justify-center items-center h-40 sm:h-64'>
            <p className='text-sm sm:text-3xl font-bold text-white mx-10 xxs:mx-0 xxs:w-[400px] text-center'>{getLang(lang).firstWorldCup.titleEvent}</p>
          </div>
        </div>
        <div className='w-full flex justify-center'>
          <div className='my-10 3xl:w-[1200px]'>
            <p className='text-sm sm:text-3xl font-bold text-primary text-center mx-10 xxs:mx-0 mb-5 sm:my-10'>{getLang(lang).firstWorldCup.aproposEvent}</p>
            <p className='text-sm sm:text-3xl font-semiBold text-center mx-10'>{getLang(lang).firstWorldCup.aproposContentEvent}</p>
          </div>
        </div>
        <div className='w-full flex justify-center'>
          <div className='h-[400px] sm:h-[700px] w-full 3xl:w-[1200px]'>
            <div className='flex w-full'>
              {firstItems.map((item, index) => {
                return (
                  <Item
                    key={index}
                    primary={item.primary}
                    icon={item.icon}
                    label={item.label}
                  />
                )
              })}
            </div>
            <div className='flex w-full relative bottom-10'>
              {secondItems.map((item, index) => {
                return (
                  <SecondItem
                    key={index}
                    primary={item.primary}
                    icon={item.icon}
                    label={item.label}
                  />
                )
              })}
            </div>
          </div>
        </div>
        <div>
          <EventForms details />
        </div>
        <div className='bg-primary pt-10 pb-2 relative bottom-10'>
          <p className='text-white text-sm sm:text-3xl font-semiBold text-center mx-10 xxs:mx-0'>{getLang(lang).firstWorldCup.dateHeureEvent}</p>
          <p className='text-white text-sm sm:text-3xl font-semiBold text-center my-2'>{getLang(lang).firstWorldCup.dateHeureContentEvent}</p>
          <TimerEvent targetDate='03-07-2025' details/>
        </div>
        {/* <div className='flex justify-center py-10'>
          <div className='flex flex-col xxs:flex-row items-center'>
            <div className='w-28 h-28 sm:w-48 sm:h-48 p-5 bg-white z-20 border-2 border-primary rounded-full flex justify-center items-center relative xxs:left-8 sm:left-2 lg:left-10'>
              <img src={organisation} alt='organisation' />
            </div>
            <div className='relative xxs:right-8 sm:right-2 lg:right-10'>
              <p className='border-2 border-primary text-xl sm:text-3xl font-semiBold rounded-[20px] text-center p-5 md:w-[550px] mx-10 sm:mx-0'>{getLang(lang).firstWorldCup.comiteOrganisationEvent}</p>
              <p className='border-2 border-primary bg-primary text-white text-xl sm:text-3xl font-semiBold rounded-[20px] text-center p-5 md:w-[550px] mx-10 sm:mx-0'>{getLang(lang).firstWorldCup.comiteOrganisationContentEvent}</p>
            </div>
          </div>
        </div> */}
        <div>
          <div className='w-full flex justify-center'>
            <div className='w-full 3xl:w-[1200px]'>
              <p className='text-sm sm:text-3xl font-semiBold text-primary text-center'>{getLang(lang).firstWorldCup.programmeEvent}</p>
              <div className='h-[500px] border-2 border-primary rounded-[20px] mx-10 my-5 flex flex-col items-center'>
                {/* <div className='flex justify-center items-center rounded-bl-[100px] rounded-br-[100px] bg-primary p-2 w-[500px]'>
                  <p className='text-white font-semiBold text-2xl'>03 Juillet 2025</p>
                </div>
                <p className='font-semiBold text-3xl py-2 mb-5'>1/8 de finale : préséléction</p>
                <p className='text-white font-semiBold text-center text-2xl rounded-full bg-primary w-[95%]'>14:00</p>
                <p className='font-semiBold text-3xl mt-2'>Présentations des travaux scientifiques</p>
                <p className='font-semiBold text-3xl mb-5'>Accueil des participants</p>
                <p className='text-white font-semiBold text-center text-2xl rounded-full bg-primary w-[95%]'>14:30</p>
                <p className='font-semiBold text-3xl mt-2 mb-5'>Présentation des équipes</p>
                <p className='text-white font-semiBold text-center text-2xl rounded-full bg-primary w-[95%]'>15:00</p>
                <p className='font-semiBold text-3xl mt-2 mb-5 w-[500px] text-center'>Battles des équipes: Part 1 (Equipes Nationales des résidents)</p> */}
              </div>
              <div className='flex flex-col xxs:flex-row xxs:justify-between xxs:items-center mx-10 xxs:gap-5'>
                <CustomButton
                  value={getLang(lang).firstWorldCup.previousDay}
                  handelClick={() => {}}
                />
                <div className='relative bottom-8 xxs:bottom-0 w-full'>
                  <CustomButton
                    value={getLang(lang).firstWorldCup.nextDay}
                    handelClick={() => {}}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='w-full bg-primary flex justify-center'>
          <div className='3xl:w-[1200px] flex flex-col items-center py-10'>
            <p className='text-sm sm:text-3xl font-semiBold text-white text-center'>{getLang(lang).firstWorldCup.locationEvent}</p>
            <img src={locationEventImages} alt='location' className='w-[60vw] my-10'/>
            <p className='text-sm sm:text-3xl font-semiBold text-white text-center sm:w-[550px] mx-10 sm:mx-0'>{getLang(lang).firstWorldCup.locationContentEvent}</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
